import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

export const StyledGiftPackCard = styled(FlexDiv)`
  gap: 8px;
  align-items: center;
  background-color: ${theme.colorsV2.gray.shade_50};
  border-radius: 12px;
  padding: 16px;
  margin: 0 0 32px;
`;

export const Content = styled(FlexDiv)`
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled(Typography)`
  color: ${theme.colorsV2.gray.shade_700};
  font-size: 14px;
  line-height: 24px;
  font-family: var(--man-500);
`;

export const Info = styled(FlexDiv)`
  gap: 8px;
`;

export const InfoIcon = styled(StyledSvgSprite)`
  height: 16px;
  width: 16px;
  fill: ${theme.colorsV2.shyft.purple_text};
`;

export const InfoText = styled(Typography)`
  flex: 1;
  color: ${theme.colorsV2.shyft.purple_text};
  font-size: 12px;
  line-height: 16px;
  font-family: var(--man-700);
`;
